import React, { useState } from 'react';
import { IdProvider } from '../types/auth';
import { IdPs } from '../constants/providers';
import { useIntl } from 'react-intl';
import { providerNameDiscriptions } from '../i18n/provider.messages';

import { Link, TextContent } from '@amzn/awsui-components-react';
import { lwaDeprecationMessages } from '../i18n/lwaDeprecation.messages';

const IdpDescription = ({
  provider,
  isMobile,
}: {
  provider: IdProvider;
  isMobile: boolean | undefined;
}): JSX.Element => {
  const { formatMessage } = useIntl();

  const [showMore, setShowMore] = useState(false);

  const handleLearnMoreClick = (e) => {
    e.preventDefault();
    setShowMore(true);
  };

  if (provider.idp === IdPs.AWSBuilderID) {
    return (
      <>
        {!isMobile ? (
          <TextContent>
            {formatMessage(
              lwaDeprecationMessages.builderIdProviderDescription,
              {
                supportLink: (str) => (
                  <>
                    <Link
                      href="https://docs.aws.amazon.com/signin/latest/userguide/sign-in-aws_builder_id.html?icmpid=docs_builder_id_console"
                      target="_blank"
                      rel="noreferrer"
                      external={true}
                      externalIconAriaLabel="AWS Builder ID User Guide (opens in a new tab)"
                    >
                      {str}
                    </Link>
                  </>
                ),
              }
            )}
            <br />
            {formatMessage(lwaDeprecationMessages.builderIdProviderNote, {
              b: (str) => <b>{str}</b>,
            })}
            <br />
          </TextContent>
        ) : (
          <TextContent>
            <div>
              {formatMessage(
                lwaDeprecationMessages.builderIdProviderDescription,
                {
                  supportLink: (str) => (
                    <>
                      <Link
                        href="https://docs.aws.amazon.com/signin/latest/userguide/sign-in-aws_builder_id.html?icmpid=docs_builder_id_console"
                        target="_blank"
                        rel="noreferrer"
                        external={true}
                        externalIconAriaLabel="AWS Builder ID User Guide (opens in a new tab)"
                      >
                        {str}
                      </Link>
                    </>
                  ),
                }
              )}
            </div>
            {!showMore ? (
              <div style={{ marginTop: '8px' }}>
                <Link href="#" onFollow={handleLearnMoreClick} variant="info">
                  {formatMessage(
                    lwaDeprecationMessages.lwaDeprecationLearnMoreButton
                  )}
                </Link>
              </div>
            ) : (
              <>
                <br />
                {formatMessage(lwaDeprecationMessages.builderIdProviderNote, {
                  b: (str) => <b>{str}</b>,
                })}
              </>
            )}
          </TextContent>
        )}
      </>
    );
  } else {
    return (
      <TextContent>
        {IdPs[provider.idp as IdPs]
          ? formatMessage(
              providerNameDiscriptions[provider.idp as IdPs] ?? '',
              {
                br: <br />,
                apnHelp: (str) => (
                  <Link
                    href="https://aws.amazon.com/partners/"
                    target="_blank"
                    rel="noreferrer"
                    external={true}
                    externalIconAriaLabel="AWS Partner Network User Guide (opens in a new tab)"
                  >
                    {str}
                  </Link>
                ),
              }
            )
          : ' '}
      </TextContent>
    );
  }
};

export default IdpDescription;
